import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="lightest" className="titleBlock-align-left use-case" mdxType="TitleBlock" />
    <h2 {...{
      "id": "explore-use-cases"
    }}>{`Explore use cases.`}</h2>
    <p>{`Our connectors can be used across departments and industries for a variety of use cases.`}</p>
    {/* Our connectors can be used across departments and industries for a variety of use cases. */}
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard ms-useCase-one" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/agreements-and-contracts/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "480px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0aaeab91cb57e2641aebe5bde4d1dce9/5530d/agreements_Thumbnail_Desktop.webp 320w", "/document-services/static/0aaeab91cb57e2641aebe5bde4d1dce9/263a4/agreements_Thumbnail_Desktop.webp 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0aaeab91cb57e2641aebe5bde4d1dce9/8980b/agreements_Thumbnail_Desktop.jpg 320w", "/document-services/static/0aaeab91cb57e2641aebe5bde4d1dce9/a3e66/agreements_Thumbnail_Desktop.jpg 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0aaeab91cb57e2641aebe5bde4d1dce9/a3e66/agreements_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "agreements-and-contracts"
    }}>{`Agreements and contracts.`}</h3>
    <p>{`Easily generate, manage, and track agreements and contracts with dynamic terms and signatures.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard ms-useCase-two" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-and-data-extraction/data-analysis/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "480px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/20c6ed7002c3784a32266a361a4babe1/5530d/data_Thumbnail_Desktop.webp 320w", "/document-services/static/20c6ed7002c3784a32266a361a4babe1/263a4/data_Thumbnail_Desktop.webp 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/20c6ed7002c3784a32266a361a4babe1/8980b/data_Thumbnail_Desktop.jpg 320w", "/document-services/static/20c6ed7002c3784a32266a361a4babe1/a3e66/data_Thumbnail_Desktop.jpg 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/20c6ed7002c3784a32266a361a4babe1/a3e66/data_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "data-analysis-and-retrieval"
    }}>{`Data analysis and retrieval.`}</h3>
    <p>{`Extract data from complex tables including cell data, column and row headers, and table properties for use in machine learning models, analysis, or storage.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard ms-useCase-three" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "480px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/540251ae3b1be9fc36d05ed1b8cf32da/5530d/publishing_Thumbnail_Desktop.webp 320w", "/document-services/static/540251ae3b1be9fc36d05ed1b8cf32da/263a4/publishing_Thumbnail_Desktop.webp 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/540251ae3b1be9fc36d05ed1b8cf32da/8980b/publishing_Thumbnail_Desktop.jpg 320w", "/document-services/static/540251ae3b1be9fc36d05ed1b8cf32da/a3e66/publishing_Thumbnail_Desktop.jpg 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/540251ae3b1be9fc36d05ed1b8cf32da/a3e66/publishing_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "content-publishing"
    }}>{`Content publishing.`}</h3>
    <p>{`Publish whitepapers and marketing content with end-user inter-activity, security controls, and analytics.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard ms-useCase-four" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/employee-onboarding-materials/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "480px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ef5a80cc3aa57e072a73fcb345da4c62/5530d/onboarding_Thumbnail_Desktop.webp 320w", "/document-services/static/ef5a80cc3aa57e072a73fcb345da4c62/263a4/onboarding_Thumbnail_Desktop.webp 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ef5a80cc3aa57e072a73fcb345da4c62/8980b/onboarding_Thumbnail_Desktop.jpg 320w", "/document-services/static/ef5a80cc3aa57e072a73fcb345da4c62/a3e66/onboarding_Thumbnail_Desktop.jpg 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/ef5a80cc3aa57e072a73fcb345da4c62/a3e66/onboarding_Thumbnail_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "onboarding-and-enrollment"
    }}>{`Onboarding and enrollment.`}</h3>
    <p>{`Deliver personalized end-to-end digital onboarding and enrollment journeys to customers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      